import { useEffect } from 'react';

export const useReactGridRowHover = () => {
  useEffect(() => {
    const handleMouseOver = (e) => {
      const cell = e.target.closest('[data-cell-rowidx]');
      if (!cell) return;
      const rowIdx = cell.dataset.cellRowidx;
      document
        .querySelectorAll(`[data-cell-rowidx="${rowIdx}"]`)
        .forEach((el) => el.classList.add('row-hover'));
    };

    const handleMouseOut = (e) => {
      const cell = e.target.closest('[data-cell-rowidx]');
      if (!cell) return;
      const rowIdx = cell.dataset.cellRowidx;
      document
        .querySelectorAll(`[data-cell-rowidx="${rowIdx}"]`)
        .forEach((el) => el.classList.remove('row-hover'));
    };

    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, []);
};

export default useReactGridRowHover;
